import React, { ReactNode } from 'react';
import { StyledTitle } from './styles';

interface Props {
  children: ReactNode;
  className?: string;
}

export const PageTitle = ({ children, ...props }: Props) => {
  return <StyledTitle {...props}>{children}</StyledTitle>;
};
